import React from "react";
import { getV2 } from "../../../api/axiosV2";

const POLLING_MS = 15000;

export const useCadeteTracking = (cityId, enablePolling = true) => {
    const [cadetes, setCadetes] = React.useState([]);
    const [nuevos, setNuevos] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [lastUpdated, setLastUpdated] = React.useState(null);

    const intervalRef = React.useRef(null);

    const fetchTracking = React.useCallback(
        (withLoader = false) => {
            if (!cityId) return;
            if (withLoader) setLoading(true);

            getV2(`/admin/cadetes/tracking/realtime?ciudad_id=${cityId}`)
                .then((response) => {
                    const data = response.data || {};
                    setCadetes(data.cadetes || []);
                    setNuevos(data.nuevos || []);
                    setError(null);
                    setLastUpdated(new Date());
                })
                .catch(() => {
                    setError("No se pudo obtener el tracking de cadetes");
                })
                .finally(() => {
                    if (withLoader) setLoading(false);
                });
        },
        [cityId]
    );

    React.useEffect(() => {
        setCadetes([]);
        setNuevos([]);
        setLastUpdated(null);
        setError(null);
        setLoading(false);

        if (!cityId) return undefined;

        fetchTracking(true);
    }, [cityId, fetchTracking]);

    React.useEffect(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (!cityId || !enablePolling) return undefined;

        intervalRef.current = setInterval(() => fetchTracking(false), POLLING_MS);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [cityId, enablePolling, fetchTracking]);

    return { cadetes, nuevos, loading, error, lastUpdated, refetch: fetchTracking };
};
